import React, { Component } from "react";
import { Table, Button } from "antd";
import { PlusOutlined, PrinterOutlined } from "@ant-design/icons";
import moment from "moment";
import { SearchBar } from "../../../components/common/search-bar";
import { AddUser } from "./add-user";
import { apiCustomer } from "../../../api/api-customer";
import { emitter } from "../../../common/utils/emitter";
import { alert } from "../../../common/utils/alert";

export class UserTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dataTable: [],
      total: 0,
      isAddUser: false,
      typeOption: "create_new",
      exportFilter: {
        customer_name: null,
        admin_name: null,
        created_at: null,
        created_by: null,
        tax_code: null,
        address: null,
      },
    };

    this.page = 1;

    this.customerTable = [
      {
        title: "STT",
        dataIndex: "index",
        key: "index",
        maxWidth: 60,
      },
      {
        title: "Khách hàng",
        dataIndex: "customer_name",
        key: "customer_name",
        render: (name) => (
          <div style={{ minWidth: 200, maxWidth: 250, textAlign: "left" }}>
            {name}
          </div>
        ),
      },
      {
        title: "MST/MS cá nhân",
        dataIndex: "data",
        key: "code",
        render: (data) => (
          <div style={{ textAlign: "right" }}>
            {data.id_card ? data.id_card : data.tax_code}
          </div>
        ),
      },
      {
        title: "Địa chỉ",
        dataIndex: "address",
        key: "address",
        render: (name) => (
          <div style={{ minWidth: 200, maxWidth: 250, textAlign: "left" }}>
            {name}
          </div>
        ),
      },
      {
        title: "Admin user",
        dataIndex: "admin_name",
        key: "admin_name",
        render: (admin_name) => (
          <div style={{ minWidth: 80 }}>{admin_name}</div>
        ),
      },
      {
        title: "Người tạo",
        dataIndex: "created_by",
        key: "created_by",
        render: (created_by) => (
          <div style={{ minWidth: 110 }}>{created_by}</div>
        ),
      },
      {
        title: "Ngày tạo KH",
        dataIndex: "created_at",
        key: "created_at",
        render: (created_at) => (
          <div style={{ minWidth: 100 }}>
            {moment(created_at).format("DD/MM/YYYY")}
          </div>
        ),
      },
      {
        title: "Chi tiết",
        dataIndex: "data",
        key: "id",
        render: (data) => (
          <div style={{ minWidth: 60 }} onClick={() => this.showDetail(data)}>
            <img
              alt=""
              className="detail-icon"
              src={require("../../../assets/icons/info-circle-solid.png")}
            />
          </div>
        ),
      },
    ];
  }

  componentDidMount() {
    this.getData(1);
  }

  showDetail = (data) => {
    this.handleAddUser(true, "show_detail", data);
  };

  handleAddUser = (status, type, data) => {
    this.setState({ isAddUser: status, typeOption: type }, () => {
      const element = document.getElementById("right-layout");
      element.scrollTo(0, 0);
      if (data) {
        this.addUsers.updateFormUser(data);
      }
      if (!status) {
        this.getData(1);
      }
    });
  };

  getData = async (page) => {
    const { state } = this.search;
    if (page) {
      this.page = page;
    } else {
      this.page = 1;
    }
    if (state.checkSearch) {
      this.setState({
        exportFilter: {
          customer_name: state.name
            ? `%${state.name
                .trim()
                .replace(/(\r\n|\n|\r)/gm, " ")
                .replace(/%/gi, "\\%")}%`
            : null,
          admin_name: state.admin_user
            ? `%${state.admin_user.trim().replace(/%/gi, "\\%")}%`
            : null,
          created_at: state.created_date ? state.created_date : null,
          created_by: state.created_user
            ? `%${state.created_user.trim().replace(/%/gi, "\\%")}%`
            : null,
          tax_code: state.tax_code
            ? `%${state.tax_code.trim().replace(/%/gi, "\\%")}%`
            : null,
          address: state.address
            ? `%${state.address.trim().replace(/%/gi, "\\%")}%`
            : null,
        },
      });
    }
    try {
      emitter.emit("FETCH_LOADING", true);
      const result = await apiCustomer.getCustomers(
        this.state.exportFilter,
        page
      );
      emitter.emit("FETCH_LOADING", false);
      if (result.status === "success") {
        const dataConvert = result.data.content.map((value, index) => {
          return {
            index: index + (page - 1) * 10 + 1,
            ...value,
            data: value,
          };
        });
        this.setState(
          { dataTable: dataConvert, total: result.data.total_elements },
          () => {}
        );
      }
    } catch (error) {
      emitter.emit("FETCH_LOADING", false);
    }
  };

  onChangePage = (page) => {
    const element = document.getElementById("right-layout");
    element.scrollTo(0, 0);
    this.getData(page, false);
  };

  handleExportUser = async () => {
    try {
      const { state } = this.search;
      const { total, exportFilter } = this.state;
      const totalItem = total < 10 ? 10 : total;
      emitter.emit("FETCH_LOADING", true);
      apiCustomer.exportCustomer(exportFilter, 1, totalItem).then((res) => {
        if (res === "success") {
          alert("success", "Export thành công");
          emitter.emit("FETCH_LOADING", false);
        } else {
          alert("error", "Không export thành công");
          emitter.emit("FETCH_LOADING", false);
        }
      });
    } catch (error) {
      alert("error", "Không export thành công");
      emitter.emit("FETCH_LOADING", false);
    }
  };

  render() {
    const { dataTable, total, isAddUser, typeOption } = this.state;
    return (
      <div className="contract-table">
        {!isAddUser ? (
          <>
            <div
              style={{
                color: "#d20a30",
                paddingTop: "20px",
                fontSize: "1em",
                display: "flex",
                alignItems: "center",
              }}
            >
              Danh sách khách hàng
            </div>
            <SearchBar
              search={this.getData}
              ref={(ref) => (this.search = ref)}
            />
            <Table
              rowKey={(record) => record.customer_id}
              style={{ width: "100%" }}
              dataSource={dataTable}
              pagination={{
                total,
                pageSize: 10,
                onChange: this.onChangePage,
                current: this.page,
              }}
              //pagination={false}
              scroll={{ x: true }}
              columns={this.customerTable}
            />
            <div className="button-container">
              <Button
                onClick={() => this.handleAddUser(true, "create_new")}
                className="add-btn"
              >
                <PlusOutlined /> Thêm khách hàng
              </Button>
              <Button className="export-btn" onClick={this.handleExportUser}>
                <PrinterOutlined /> Export
              </Button>
            </div>
          </>
        ) : (
          <AddUser
            typeOption={typeOption}
            ref={(ref) => (this.addUsers = ref)}
            close={() => this.handleAddUser(false)}
          />
        )}
      </div>
    );
  }
}
